import React, { useEffect, useRef } from "react";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import Check from "../../../svgs/FilledCheck";

type ScrollAreaOptionsType = {
  selected?: string;
  showOptions: (value: boolean) => void;
  children: React.ReactNode[];
  selectOneOption?: boolean;
  clickOutsideBehavior?: () => void;
};

const ScrollAreaOptions: React.FC<ScrollAreaOptionsType> = ({
  showOptions,
  children,
  selected,
  selectOneOption,
  clickOutsideBehavior,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [calculatedHeight, setCalculatedHeight] = React.useState("0");

  useEffect(() => {
    const actualHeight = children.length * 40 + (selectOneOption ? 40 : 0); // 40 is the height of each option
    setCalculatedHeight(actualHeight > 440 ? "440" : actualHeight.toString());
  }, [children]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node) &&
        event.target.id !== "profession"
      ) {
        clickOutsideBehavior && clickOutsideBehavior();
        showOptions(false);
      }
    };

    setTimeout(() => {
      document.addEventListener("click", handleClickOutside);
    }, 100);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="relative"
      ref={containerRef}
      onBlur={() => showOptions(false)}
    >
      <div className="absolute top-0 left-0 z-30 w-full">
        <ScrollArea.Root
          type="auto"
          className={`bg-forest-100 rounded-xl overflow-hidden`}
          style={{ height: `${calculatedHeight}px` }}
        >
          <ScrollArea.Viewport className="size-full">
            {selectOneOption && (
              <li
                className={`${
                  selected === "Select one"
                    ? "bg-forest-200 font-medium"
                    : "font-normal"
                }
          flex justify-between items-center self-stretch py-2 pr-2 pl-4 hover:bg-forest-200`}
              >
                Select one
                {selected === "Select one" && (
                  <Check
                    className="w-4 h-4"
                    stroke="#123333"
                    background="#DEE3E3"
                  />
                )}
              </li>
            )}
            {children}
          </ScrollArea.Viewport>
          <ScrollArea.Scrollbar
            className="flex touch-none select-none rounded-xl bg-transparent p-0.5 data-[orientation=vertical]:w-2.5"
            orientation="vertical"
          >
            <ScrollArea.Thumb
              className="relative flex-1 rounded-[10px] bg-forest-500
          before:absolute before:left-1/2 before:top-1/2 before:size-full before:min-h-11 before:min-w-11 before:-translate-x-1/2 before:-translate-y-1/2"
            />
          </ScrollArea.Scrollbar>
        </ScrollArea.Root>
      </div>
    </div>
  );
};

export default ScrollAreaOptions;
